/**
 * Focus app — /apps/focus/*
 *
 * One job: a team lead wants the team pointed at the few things that matter
 * this period — visibly, durably. Two screens (C Mode): the list (what we're
 * committed to, and the pool behind it) and the re-focus ritual.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import FocusListScreen from './FocusListScreen';
import RefocusScreen from './RefocusScreen';

export default function FocusApp() {
  const app = getAppDefinition('focus')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<FocusListScreen />} />
        <Route path=":collectionId" element={<FocusListScreen />} />
        <Route path=":collectionId/refocus" element={<RefocusScreen />} />
        <Route path="*" element={<Navigate to="/apps/focus" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
